import { FaArrowLeft, FaShareAlt } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';

import { BrandColors } from 'constants/brand-colors';

import miaPhoto from 'assets/avatars/instagram.jpg';

import { SOCIAL_ICON_LG_PX, SOCIAL_ICON_MD_PX } from '../constants';
import * as styled from '../styles/social-bios';
import { AnimatedLinkBox } from './animated-link-box';

export const TikTokCard = ({
  initials,
  name,
  profession,
  slug,
  phase,
  enterDelay,
}: Landing.SocialBioCardContent & {
  phase: Landing.SocialBioPhase;
  enterDelay: number;
}) => (
  <styled.Card $isGood={phase === 'good'}>
    <styled.TtScreen>
      <styled.TtTopRow>
        <FaArrowLeft size={SOCIAL_ICON_MD_PX} />
        <SiTiktok size={SOCIAL_ICON_LG_PX} />
        <FaShareAlt size={SOCIAL_ICON_MD_PX} />
      </styled.TtTopRow>
      <styled.Avatar
        $size={5.4}
        $accent={BrandColors.tiktokMagenta}
        $photoUrl={miaPhoto}
      >
        {initials}
        <styled.FollowBadge>+</styled.FollowBadge>
      </styled.Avatar>
      <styled.TtCenteredHandle>@{slug}</styled.TtCenteredHandle>
      <styled.TtStatRow>
        <styled.TtStatCol>
          <styled.TtStatNumber>312</styled.TtStatNumber>
          <styled.TtStatLabel>Following</styled.TtStatLabel>
        </styled.TtStatCol>
        <styled.TtStatCol>
          <styled.TtStatNumber>48k</styled.TtStatNumber>
          <styled.TtStatLabel>Followers</styled.TtStatLabel>
        </styled.TtStatCol>
        <styled.TtStatCol>
          <styled.TtStatNumber>620k</styled.TtStatNumber>
          <styled.TtStatLabel>Likes</styled.TtStatLabel>
        </styled.TtStatCol>
      </styled.TtStatRow>
      <styled.TtActionRow>
        <styled.TtFollowButton>Follow</styled.TtFollowButton>
        <styled.TtMessageButton>Message</styled.TtMessageButton>
      </styled.TtActionRow>
      <styled.TtBioBlock>
        <styled.TtBioText>
          {name} · {profession}
        </styled.TtBioText>
        <AnimatedLinkBox phase={phase} slug={slug} enterDelay={enterDelay} />
      </styled.TtBioBlock>
    </styled.TtScreen>
  </styled.Card>
);
